export const PLANNED_MINUTES_FALLBACK = 120;

function isDefined(value) {
  return value !== undefined && value !== null;
}

function toNumber(value) {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

// Keep fallback order consistent across the app: plannedMinutes ?? plannedDurationMinutes ?? 120
export function resolvePlannedMinutes(source) {
  const direct = isDefined(source?.plannedMinutes)
    ? source?.plannedMinutes
    : isDefined(source?.plannedDurationMinutes)
      ? source?.plannedDurationMinutes
      : isDefined(source?.planning?.plannedMinutes)
        ? source?.planning?.plannedMinutes
        : source?.planning?.plannedDurationMinutes;

  if (!isDefined(direct) || direct === "") {
    return PLANNED_MINUTES_FALLBACK;
  }

  const numeric = toNumber(direct);
  if (numeric === null) return PLANNED_MINUTES_FALLBACK;
  return Math.max(0, Math.round(numeric));
}

export function formatPlannedMinutes(minutesInput) {
  const minutes = Math.max(0, Math.round(toNumber(minutesInput) ?? PLANNED_MINUTES_FALLBACK));
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;

  if (remainder === 0) {
    return `${hours} uur`;
  }

  return `${hours} uur ${remainder} min`;
}

export function parsePositiveWholeMinutes(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  if (!/^\d+$/.test(raw)) return null;

  const numeric = Number(raw);
  if (!Number.isInteger(numeric) || numeric <= 0) return null;
  return numeric;
}
